import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";import React from 'react';
import Button from "../../Button";
import Add from "../../../icons/Add";


import { PRODUCT_LINES_CONTENT_MAP, ProductLineSectionType } from "../../../utils/ProductLinesHelper";
import SidebarProposalCard from "../SidebarProposalCard";
import { createStyles } from "./styles";
import Legal from "../../../icons/Legal";




























var ProductLineSection = function ProductLineSection(_ref)






{var productLineId = _ref.productLineId,cartItems = _ref.cartItems,onProductLineChange = _ref.onProductLineChange,_ref$productLineSecti = _ref.productLineSection,productLineSection = _ref$productLineSecti === void 0 ? ProductLineSectionType.GENERAL : _ref$productLineSecti,onRemoveFromProposal = _ref.onRemoveFromProposal,onCompareAllPortfoliosInPl = _ref.onCompareAllPortfoliosInPl;
  var classes = createStyles({ cartItemsQuantity: cartItems.length, productLineSection: productLineSection });

  var ProposalCards = _mapInstanceProperty(cartItems).call(cartItems, function (_ref2) {var portfolioId = _ref2.portfolioId,portfolioName = _ref2.portfolioName,browsingCriteria = _ref2.browsingCriteria;
    return /*#__PURE__*/(
      React.createElement(SidebarProposalCard, {
        key: portfolioId,
        portfolioId: portfolioId,
        title: portfolioName,
        versionsCount: _Object$keys(browsingCriteria).length,
        removeFromProposal: onRemoveFromProposal }));


  });
  return /*#__PURE__*/(
    React.createElement("div", { className: classes.productLineSection }, /*#__PURE__*/
    React.createElement("div", { className: classes.productLineBlock }, /*#__PURE__*/
    React.createElement(Button, {
      type: "text",
      leftIconProp:
      productLineSection === ProductLineSectionType.GENERAL ?
      PRODUCT_LINES_CONTENT_MAP[productLineId].icon('2.4rem') :
      undefined,

      className: classes.pLineButton,
      size: productLineSection === ProductLineSectionType.GENERAL ? 'medium' : 'small',
      onClick: function onClick() {
        onProductLineChange(productLineId);
      } },

    PRODUCT_LINES_CONTENT_MAP[productLineId].label),

    cartItems.length > 1 && /*#__PURE__*/
    React.createElement(React.Fragment, null,
    productLineSection === ProductLineSectionType.GENERAL ? /*#__PURE__*/
    React.createElement(Button, {
      type: "text",
      size: "small",
      color: "primary",
      className: classes.comparePortfoliosButton,
      onClick: function onClick() {
        onCompareAllPortfoliosInPl(productLineId);
      } }, "Compare") : /*#__PURE__*/




    React.createElement(Button, {
      type: "icon",
      color: "primary",
      onClick: function onClick() {
        onCompareAllPortfoliosInPl(productLineId);
      } }, /*#__PURE__*/

    React.createElement(Legal, null)))),





    cartItems.length > 0 ?
    ProposalCards : /*#__PURE__*/

    React.createElement(Button, {
      type: "text",
      color: "primary",
      leftIconProp: /*#__PURE__*/React.createElement(Add, null),
      className: classes.addButton,
      onClick: function onClick() {
        onProductLineChange(productLineId);
      } },

    productLineSection === 'GENERAL' ? "Add ".concat(
    PRODUCT_LINES_CONTENT_MAP[productLineId].label) :
    'Add')));




};

export default ProductLineSection;
//# sourceMappingURL=index.js.map